import HeroSection from "../components/HeroSection";
import HotelWelcomeSection from "../components/HotelWelcomeSection";
import RoomShowcaseSection from "../components/RoomShowcaseSection";
import ServicesSection from "../components/ServicesSection";
import LuxuryLivingSection from "../components/LuxuryLivingSection";
import AmenitiesSection from "../components/AmenitiesSection";
import TrendingSearchesSection from "../components/TrendingSearchesSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <HotelWelcomeSection />
      <RoomShowcaseSection />
      <ServicesSection />
      <LuxuryLivingSection />
      <AmenitiesSection />
      <TrendingSearchesSection />
    </>
  );
};

export default Home;
